import { createDecisionMatter } from "../models";

/*
 * Promotes an existing engine recommendation into a governance dossier.
 * The recommendation is retained intact and remains the analytical source of
 * truth. Governance-specific narrative must be supplied by the caller rather
 * than calculated in the presentation layer.
 */
export function decisionMatterAdapter(
  recommendation,
  governance = {}
) {
  if (!recommendation) {
    return null;
  }

  const evidence = recommendation.evidence;
  const defaultEvidence = evidence == null
    ? []
    : Array.isArray(evidence)
      ? evidence
      : [evidence];
  const metadata = recommendation.metadata || {};

  return createDecisionMatter({
    ...governance,
    id: governance.id ?? null,
    businessQuestion:
      governance.businessQuestion ??
      metadata.businessQuestion ??
      null,
    decisionRequired:
      governance.decisionRequired ??
      metadata.decisionRequired ??
      null,
    alternatives:
      governance.alternatives ??
      evidence?.alternatives ??
      [],
    recommendation,
    recommendationStatus:
      governance.recommendationStatus ??
      recommendation.status ??
      null,
    recommendedAlternative:
      governance.recommendedAlternative ??
      metadata.recommendedAlternative ??
      recommendation.strategy ??
      null,
    supportingEvidence:
      governance.supportingEvidence ?? defaultEvidence,
    financialImpact:
      governance.financialImpact ??
      recommendation.financialImpact ??
      null,
    riskImpact:
      governance.riskImpact ??
      recommendation.riskImpact ??
      null,
    sourceRecommendation:
      governance.sourceRecommendation ??
      metadata.sourceRecommendation ??
      recommendation,
    createdFromRecommendationId:
      governance.createdFromRecommendationId ??
      metadata.createdFromRecommendationId ??
      recommendation.id ??
      null,
    sourceReference:
      governance.sourceReference ??
      metadata.sourceReference ??
      null,
    metadata: {
      recommendationId: recommendation.id ?? null,
      source: recommendation.source ?? null,
      engine: recommendation.engine ?? null,
      ...metadata,
      ...(governance.metadata || {}),
    },
  });
}

export default decisionMatterAdapter;
